import ajax from "../utils/request.js";
//礼品

//礼品列表 get /api/gift/lists
const giftlists = (data) => {
  return ajax.get("/api/gift/lists", data);
};
//添加礼品秘钥 post /api/gift/add
const giftadd = (data) => {
  return ajax.post("/api/gift/add", data);
};
//编辑礼品秘钥 post /api/gift/edit
const giftedit = (data) => {
  return ajax.post("/api/gift/edit", data);
};

//删除礼品秘钥 post /api/gift/delete
const giftDel = (data) => {
  return ajax.post("/api/gift/delete", data);
};

//礼品发放列表 get /api/issue/lists
const issuelists = (data) => {
  return ajax.get("/api/issue/lists", data);
};
//发送秘钥 get /api/issue/send
const issuesend = (data) => {
  return ajax.post("/api/issue/send", data);
};
//礼品发放列表导出 get /api/issue/export
const issueexport = (data) => {
  return ajax.gets("/api/issue/export", data);
};
export {
  giftlists,
  giftadd,
  giftedit,
  issuelists,
  issuesend,
  issueexport,
  giftDel
  
}